import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.393 4.184a1.986 1.986 0 0 0-2.786 0 1.92 1.92 0 0 0 0 2.738 1.985 1.985 0 0 0 2.786 0 1.92 1.92 0 0 0 0-2.738m-3.771-.995a3.386 3.386 0 0 1 4.756 0 3.32 3.32 0 0 1 0 4.728 3.386 3.386 0 0 1-4.756 0 3.32 3.32 0 0 1 0-4.728m-.289 7.899c-.798 0-1.433.639-1.433 1.412v.587a.7.7 0 1 1-1.4 0V12.5c0-1.56 1.275-2.812 2.833-2.812h5.334c1.558 0 2.833 1.252 2.833 2.812v.587a.7.7 0 1 1-1.4 0V12.5c0-.773-.635-1.412-1.433-1.412z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UserIcon16.js.map